import Base from './base'
import urls from 'config/urls'

class Product extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.product.find,
      data: opts
    })
  }

  findByCategroy (opts) {
    return this.httpGet({
      url: urls.product.findByCategroy,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.product.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.product.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.product.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.product.delete,
      data: opts
    })
  }

  copyFromSample (opts) {
    return this.httpPost({
      url: urls.product.copyFromSample,
      data: opts
    })
  }

  findAttribute (opts) {
    return this.httpGet({
      url: urls.product.findAttribute,
      data: opts
    })
  }

  createAttribute (opts) {
    return this.httpPost({
      url: urls.product.createAttribute,
      data: opts
    })
  }

  updateAttribute (opts) {
    return this.httpPost({
      url: urls.product.updateAttribute,
      data: opts
    })
  }

  deleteAttribute (opts) {
    return this.httpPost({
      url: urls.product.deleteAttribute,
      data: opts
    })
  }

  findMedia (opts) {
    return this.httpGet({
      url: urls.product.findMedia,
      data: opts
    })
  }

  createMedia (opts) {
    return this.httpPost({
      url: urls.product.createMedia,
      data: opts
    })
  }

  deleteMedia (opts) {
    return this.httpPost({
      url: urls.product.deleteMedia,
      data: opts
    })
  }

  attachCategory (opts) {
    return this.httpPost({
      url: urls.product.attachCategory,
      data: opts
    })
  }

  detachCategory (opts) {
    return this.httpPost({
      url: urls.product.detachCategory,
      data: opts
    })
  }
}

export default new Product



// WEBPACK FOOTER //
// ./src/models/product.js